export const styles = {
  h1: {
    margin: "0px 0 48px",
    fontSize: "30px",
    lineHeight: "46px",
    fontWeight: 600
  },
  h2: {
    margin: "0",
    marginTop: "0",
    marginBottom: "30px",
    paddingTop: "60px",
    fontSize: 22,
    fontWeight: 600,
    position: "relative",
    zIndex: -1
  },
  h3: {
    margin: "0",
    paddingTop: "30px",
    paddingBottom: "5px",
    fontSize: 18,
    fontWeight: 600
  },
  h4: {
    margin: "0",
    paddingTop: "30px",
    fontSize: 16,
    fontWeight: 600
  },
  h5: {
    fontSize: 18,
    fontWeight: 600
  },
  h6: {
    fontSize: 16,
    fontWeight: 600
  },
  list: {
    padding: 0,
    margin: "10px 0 10px 20px"
  },
  pre: {
    margin: "25px 0 40px 0",
    fontSize: 15
  }
};
